import dynamic from "next/dynamic";

export const DynamicHero036 = dynamic(() => import("./Hero036"), {
  suspense: true,
});
